import { PENETAPAN_PREDIKAT_KINERJA_RATING_MAPPING } from 'app/KinerjaShared/constants/penetapanPredikatKinerja'

import type {
  TPerformancePracticeResult,
  TPredicateRecommendationResult,
  TWorkBehaviorResult,
} from 'types/kinerja-pelaksanaan'

export const generatePredikatKinerja = (
  praktikKinerjaRating: TPerformancePracticeResult,
  perilakuKerjaRating: TWorkBehaviorResult
): TPredicateRecommendationResult | undefined => {
  return PENETAPAN_PREDIKAT_KINERJA_RATING_MAPPING[
    `${praktikKinerjaRating}-${perilakuKerjaRating}`
  ]
}
